<script setup>
    import { ref, computed, inject } from 'vue'
    import { RouterLink } from 'vue-router'
    import { useUserStore } from "../pages/user/stores/user";
    import { useSiteMenuStore } from "../stores/sitemenu";
    import { useNavigationStore } from "../stores/navigation";
    import { useAlertStore } from '../stores/alertStore';
    import { useRoute, useRouter } from 'vue-router'
    import { storeToRefs } from "pinia";
    import GNB from './nav/GNB.vue'
    import LNB from './nav/LNB.vue'
    import LNBAdmin from './nav/LNBAdmin.vue'
    import LNBPartAdmin from "./nav/LNBPartAdmin.vue";
    import _ from 'lodash'
    import {useDeviceStore} from "@/stores/device";

    const userStore = useUserStore()
    const { user, isAuthenticated, isAdmin, isPartAdmin, isSysAdmin } = storeToRefs(userStore);
    const { isAdminView, isPartAdminView, isSysAdminView } = storeToRefs(useNavigationStore())
    const siteMenuStore = useSiteMenuStore();
    let corpMasterYn = ''
    const setup = () => {
      const userInStorage = sessionStorage.getItem('user')
      if(userInStorage) {
        const { userInfo } = JSON.parse(userInStorage)
        corpMasterYn = userInfo.corpMasterYn;
      }
    }

    const onLogoutModal = inject('onLogoutModal');

    const masterMenuId = [96]; // 상시채용관 현황(96)

    // 모바일 반응형 메뉴 숨김
    // 채용박람회 현황(72,73), 상시채용관 현황(95, 96), 기업 입사지원 현황 (98), 기업홍보관 현황(99), 기업공채관 현황(105, 106)
    const hideMobileMenu = [72, 73, 95, 96, 98, 99, 105, 106];

    const route = useRoute()
    const router = useRouter()

    const showDropdown = ref(false);

    const { $alert } = useAlertStore();

    const deviceStore = useDeviceStore();

    const myPageMenu = computed(()=> {
      setup();
      const originalMenu = _.find(siteMenuStore.menuList, { menuAreaGb: '02', menuId: 29});
      if(originalMenu !== undefined) {
        const filterMenu = [];
        for(let i=0; i < originalMenu.child.length; i++) {
         // console.log(i + " - corpMasterYn - " + corpMasterYn);
          if(masterMenuId.indexOf(originalMenu.child[i].menuId) > -1) {
            if(corpMasterYn === 'Y'){
              filterMenu.push(originalMenu.child[i]);
            }
          } else {
            filterMenu.push(originalMenu.child[i]);
          }
        }
        filterMenu.menuName = originalMenu.menuName;
        return filterMenu;
      } else {
        return originalMenu;
      }
    })

    const myPageMenuChild = computed(()=> {
        if(isAdmin.value) {
            return _.filter(myPageMenu.value, { menuName: '내 정보'});
        } else {
            return myPageMenu.value;
        }
    })

    // 모바일 반응형 메뉴 숨김
    const myPageMenuMobileFilter = computed(()=> {
        if(deviceStore.isMobile) {
          return myPageMenuChild.value.filter(menu => !hideMobileMenu.includes(menu.menuId));
        } else {
          return myPageMenuChild.value;
        }
    })

    const showLNB = computed(()=>{
        return route && route.name && route.name !== 'Home' && route.name !== 'NotFound' && !route.name.startsWith('Signin') && !route.name.startsWith('Signup');
    })

    // 메뉴 수정/메뉴 추가 시, 수정 필요 1-1 (1~7)
    const getRouterNameforAdmin = (accessMenu) => {
        let menu = 'MemberList'
        if ( accessMenu.indexOf('us') > -1 ) {
            menu = 'MemberList'
        } else if ( accessMenu.indexOf('co') > -1 ) {
            menu = 'CorporationList'
        } else if ( accessMenu.indexOf('lt') > -1 ) {
            menu = 'LectureList'
        } else if ( accessMenu.indexOf('cr') > -1 ) {
            menu = 'LectureCourseList'
        } else if ( accessMenu.indexOf('hr') > -1 ) {
            menu = 'UserMatchingList'
        } else if ( accessMenu.indexOf('jf') > -1 ) {
            menu = 'OjfList'
        } else if ( accessMenu.indexOf('mg') > -1 ) {
            menu = 'MailSMSHistory'
        } else if ( accessMenu.indexOf('cs') > -1 ) {
            menu = 'CSNotifyList'
        } else if ( accessMenu.indexOf('st') > -1 ) {
            menu = 'SiteMainBanner'
        } else if ( accessMenu.indexOf('am') > -1 ) {
            menu = 'ManagerList'
        } else if ( accessMenu.indexOf('pa') > -1 ) {
            menu = 'PartnerList'
        }
      return menu;
    }

    // 메뉴 수정/메뉴 추가 시, 수정 필요 1-2 (1~7)
    const getRouterNameforPartAdmin = (accessMenu) => {
      let menu = 'PartnerLectureList'
      if ( accessMenu.indexOf('lt') > -1 ) {
          menu = 'PartnerLectureList'
      } else if ( accessMenu.indexOf('cr') > -1 ) {
          menu = 'PartnerLectureCourseList'
      }
      return menu;
    }

    // 한국반도체아카데미 로고 클릭
    // 시스템 관리자, 담당기관 관리자 모두 어드민에 포함되므로 isAdmin, isAdminView 둘 다 true
    const onClickLogo = () => {
        let menu = 'Home'; // 일반 사용자
        let accessMenu = user.value.accessMenu;

        if(isAdminView.value)  {
            if(isPartAdminView.value)  {
                menu = getRouterNameforPartAdmin(accessMenu);
            } else if (isSysAdminView.value)  {
                menu = 'SchedulerManage';
            } else {
                menu = getRouterNameforAdmin(accessMenu);
            }
        }
        router.push({name: menu});
    }

    const onClickMenu = (menu) => {
        const closeMenuId = [33, 34];
        if(closeMenuId.indexOf(menu.menuId) > -1) {
            $alert("준비중 입니다.");
        } else{
            router.push(menu.menuUrl);
        }
    }

    const isCurrentRoute = (menuUrl) => {
        const _route = isProxy(route) ? toRaw(route) : route;
        return _route.fullPath.value.indexOf(menuUrl) > -1;

    }

    // 시스템 관리자 클릭: SchedulerManage, 관리자 사이트 클릭: MemberList
    const goAdminView = (isSysAdmin) => {
        let accessMenu = user.value.accessMenu;
        let menu = getRouterNameforAdmin(accessMenu);
        router.push({name: isSysAdmin ? 'SchedulerManage' : menu});
    }

    // 담당기관 사이트 클릭: PartnerLectureList
    const goPartAdminView = () => {
        let accessMenu = user.value.accessMenu;
        let menu = getRouterNameforPartAdmin(accessMenu);
        router.push({name: menu});
    }

    const logout = () => {
        userStore.setUser({});
        siteMenuStore.getSiteMenu()
        router.push({name: 'Home'});
        onLogoutModal();
        $alert("로그아웃 되었습니다.");
    };

    document.body.addEventListener('click', function(event){
        if(!event.target.closest('.inner-username')) showDropdown.value = false;
    })
</script>

<template>
    <header class="header" :class="{'home-style': route.name === 'Home', 'admin-header': isAdminView}"> <!-- admin-header -->
        <div class="inner">
            <h1 class="logo-wrap" @click="onClickLogo">
                <img src="/src/assets/images/logo.svg" alt="KSA 한국반도체아카데미" class="logo" />
                <img src="/src/assets/images/logo_w.svg" alt="KSA 한국반도체아카데미" class="logo_w" />
            </h1>
            <div class="header-top">
                <div v-if="!isAuthenticated" style="padding-top: 23px;">
                    <span><RouterLink :to="{name: 'Signin'}">로그인</RouterLink></span>
                    <span><RouterLink :to="{name: 'Signup'}">회원가입</RouterLink></span>
                    <span class="mobile_hide"><RouterLink :to="{name: 'SigninAdmin'}">관리자사이트</RouterLink></span>
                </div>
                <div v-else style="padding-top: 11px;">
                    <span class="inner-username" :class="{'open': showDropdown}" @click="showDropdown = !showDropdown;">
                        <a> {{ user.userLoginId }}<span class="user-gb">{{ $userGbKR(user.userGb) }}</span></a>
                        <div v-show="showDropdown">
                            <ul v-if="myPageMenu">
                                <li v-for="childMenu in myPageMenuMobileFilter" @click="onClickMenu(childMenu)">
                                    {{ childMenu.menuName }}
                                </li>
                                <li v-if="isAdmin" @click="router.push({name: 'Home'})">
                                    사용자 사이트
                                </li>
                                <li v-if="isAdmin && !isPartAdmin && !deviceStore.isMobile" @click="goAdminView(false)">
                                    관리자 사이트
                                </li>
                                <li v-if="isPartAdmin" @click="goPartAdminView()">
                                    담당기관 사이트
                                </li>
                                <li v-if="isSysAdmin" @click="goAdminView(true)">
                                    시스템 관리자
                                </li>
                                <li class="btn-logout" @click="logout">
                                    로그아웃
                                </li>
                            </ul>
                        </div>
                    </span>
                </div>

            </div>
            <GNB v-if="!isAdminView" />
        </div>
    </header>
    <LNB v-if="!isAdminView && showLNB"/>
    <LNBPartAdmin v-if="isPartAdminView && showLNB"/>
    <LNBAdmin v-else-if="isAdminView && showLNB"/>
</template>

<style lang="scss" scoped>
@import "../assets/scss/theme";

.header {
    position: absolute;
    top: 0px;
    left: 50%;
    width: 100%;
    height: 116px;
    z-index: 2;
    background: #fff;
    transform: translateX(-50%);
    border-bottom: $border_line;
    padding:0 20px;
    &.admin-header {
        background-color: $blue_color;
        top: 0px;
        height: 80px;
        .logo-wrap {
            top: 50%;
            transform: translateY(-50%);
            padding: 0;
            .logo {
                display: none;
            }
            .logo_w {
                display: block;
            }
        }
        .header-top {
            position: absolute;
            top: 50%;
            right: 30px;
            transform: translateY(-50%);
            padding-bottom: 20px;
            span {
                > a {
                    color:  #fff;
                }
            }
        }
        .gnb-wrap {
            display: none;
        }
    }
    &.on {
        &:before, &:after {
            content: "";
            position: absolute;
            left: 0;
            width: 100%;
        }
        &:before {
            height: 492px;
            background: #fff;
            border-bottom: $border_line;
            z-index: 0;
        }
        &:after {
            top: 115px;
            border-bottom: $border_line;
            z-index: 0;
        }
    }
    &.home-style {
        position: absolute;
        top: 0;
        width: 100%;
        background: transparent;
        border-bottom: 0;
        .logo-wrap {
            .logo {
                display: none;
            }
            .logo_w {
                display: block;
            }
        }
        &.on {
            .logo-wrap {
                .logo {
                    display: block;
                }
                .logo_w {
                    display: none;
                }
            }
        }
    }
    .header-top {
        position: relative;
        text-align: right;
        z-index: 2;
        span {
            position: relative;
            cursor: pointer;
            color: $gray_color;
            margin-left: 30px;
            > a {
                text-decoration: none;
            }
            div {
                position: absolute;
                right: 0;
                width: 160px;
                z-index: 1;
                padding-top: 8px;
                ul {
                    background: #fff;
                    border: $border_line;
                    border-radius: 4px;
                    text-align: left;
                    @include font-size_xs;
                    padding: 20px;
                    li {
                        margin-bottom: 16px;
                        color: #000;
                        &:last-child {
                            margin-bottom: 0;
                        }
                        &:hover {
                            color: $blue_color;
                            a {
                                cursor: pointer;
                            }
                        }
                    }
                }
            }
        }
        .user-gb {
          border-radius: 2px;
          border: 1px solid #5599FF;
          color: #5599FF;
          display: inline-block;
          padding: 5px 4px 5px 4px;
          margin-left: 5px;
        }
    }
    .logo-wrap {
        width: 200px;
        position: absolute;
        top: 52px;
        cursor: pointer;
        z-index: 3;
        .logo {
            display: block;
        }
        .logo_w {
            display: none;
        }
    }
}
</style>